import EventBG from '../../assets/EventBG.jpg';
import { Navbar } from '../../components/Navbar';

import { useSelector, useDispatch } from 'react-redux';
import { getAllEvents, updateEvent, clearError } from '../../redux/slices/eventsSlice';
import { useEffect, useState } from 'react';
import { EventTable } from '../../components/EventTable';

import { EventContentModal } from '../../components/EventContentModal';
import { DeleteEventModal } from '../../components/DeleteEventModal';
import { AddEventModal } from '../../components/AddEventModal';
import { LoadingModal } from '../../components/LoadingModal';
import { UpdateEventModal } from '../../components/UpdateEventModal';

const EventListPage = () => {
  const dispatch = useDispatch();
  const events = useSelector((state) => state.events.events);
  const loading = useSelector((state) => state.events.loading);
  const error_message = useSelector((state) => state.events.error);
  const [updateEventModal, setUpdateEventModal] = useState(false);
  const [deleteEventModal, setDeleteEventModal] = useState(false);
  const [addEventModal, setAddEventModal] = useState(false);
  const [viewContentModal, setViewContentModal] = useState(false);
  const [viewEvent, setViewEvent] = useState(null);

  useEffect(() => {
    dispatch(getAllEvents());
  }, [dispatch]);

  const handleUpdate = (e) => {
    e.preventDefault();
    dispatch(updateEvent(viewEvent._id));
    setUpdateEventModal(false);
    setViewEvent(null);
  };

  const handleDismissError = () => {
    dispatch(clearError());
  };

  return (
    <div className="bg-sky-200">
      <Navbar src={EventBG} pageName={`Event List`} pageText={''} />
      {updateEventModal && (
        <UpdateEventModal
          handleUpdate={handleUpdate}
          setUpdateModal={setUpdateEventModal}
          viewEvent={viewEvent}
        />
      )}

      {addEventModal && <AddEventModal setAddEventModal={setAddEventModal} />}

      {deleteEventModal && (
        <DeleteEventModal
          setDeleteModal={setDeleteEventModal}
          setViewEvent={setViewEvent}
          viewEvent={viewEvent}
        />
      )}
      {viewContentModal && (
        <EventContentModal setViewContentModal={setViewContentModal} viewEvent={viewEvent} />
      )}
      {(loading || error_message) &&
        !deleteEventModal &&
        !updateEventModal &&
        !addEventModal &&
        !viewContentModal && (
          <LoadingModal
            message="Loading events..."
            error={error_message}
            onClose={error_message ? handleDismissError : null}
          />
        )}
      {
        <EventTable
          events={events}
          setDeleteModal={setDeleteEventModal}
          setUpdateModal={setUpdateEventModal}
          setViewContentModal={setViewContentModal}
          loading={loading}
          setViewEvent={setViewEvent}
          setAddEventModal={setAddEventModal}
        />
      }
    </div>
  );
};

export { EventListPage };
